// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3c7de18","eventInfoWrapper":"_73a3d25"};